import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { features } from '../config/settings/features'

/**
 * Gets a organization by the given identifier.
 */
export const getOrganization = factoryService(({ id }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.search'] ? 'compra-agil-busqueda' : 'compra-agil'
    }/organismo/${id}`
  )
)

/**
 * Gets a list of organizations by the given pattern.
 */
export const getOrganizations = factoryService(({ pattern }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.search'] ? 'compra-agil-busqueda' : 'compra-agil'
    }/organismo/autocomplete?q=${pattern}`
  )
)
